import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'imageCard',
    props: {
        imgData: null
    },
    setup(__props) {
        const props = __props;
        const privacyMode = localStorage.getItem('privacyMode') || 'false';
        const activeBorderColor = colors.borderItemHover;
        const captureTime = computed(() => {
            const time = props.imgData.captureTime;
            return moment(isNaN(time) ? time : Number(time * 1000)).format('yyyy-MM-DD HH:mm:ss');
        });
        return { __sfc: true, props, privacyMode, activeBorderColor, captureTime, BlurPicture };
    }
});
